import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/noEb8q6RZ64AzhguvHbyeS/WhatsApp_Image_2026-04-15_at_16.02.36_(1).jpg';
export const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Portfolio',
    href: '#portfolio'
  }, {
    name: 'Proceso',
    href: '#proceso'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-dark-bg/80 backdrop-blur-md border-b border-white/10 py-3' : 'bg-transparent py-5'}`} data-id="element-99">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-100">
        <a href="#inicio" className="flex items-center gap-3 group" data-id="element-101">
          <img src={LOGO_URL} alt="Impulsador Digital Logo" className="w-10 h-10 rounded-full border border-white/20 group-hover:border-neon-blue transition-colors" data-id="element-102" />
          <span className="font-display font-bold text-xl tracking-wider hidden sm:block" data-id="element-103">
            IMPULSADOR <span className="text-neon-blue" data-id="element-104">DIGITAL</span>
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-105">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-silver hover:text-neon-blue transition-colors" data-id="element-106">
              {link.name}
            </a>)}
          <a href="https://wa.me/5493416660996" target="_blank" rel="noopener noreferrer" className="px-5 py-2 rounded-full border border-neon-blue text-neon-blue font-medium hover:bg-neon-blue hover:text-dark-bg transition-all duration-300 text-sm box-glow" data-id="element-107">
            Contacto
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-silver hover:text-neon-blue" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-108">
          {isMobileMenuOpen ? <X size={24} data-id="element-109" /> : <Menu size={24} data-id="element-110" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-111">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 bg-dark-surface border-b border-white/10 md:hidden" data-id="element-112">
            <nav className="flex flex-col p-6 gap-4" data-id="element-113">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-lg font-medium text-silver hover:text-neon-blue transition-colors" data-id="element-114">
                  {link.name}
                </a>)}
              <a href="https://wa.me/5493416660996" target="_blank" rel="noopener noreferrer" className="mt-4 px-6 py-3 rounded-full bg-neon-blue text-dark-bg font-bold text-center" data-id="element-115">
                Consultar por WhatsApp
              </a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
};